function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.82 2H7.18C5.05 2 3.32 3.74 3.32 5.86v14.09c0 1.8 1.29 2.56 2.87 1.69l4.88-2.71c.52-.29 1.36-.29 1.87 0l4.88 2.71c1.58.88 2.87.12 2.87-1.69V5.86C20.68 3.74 18.95 2 16.82 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 9.9h-1.75V8.21c0-.41-.34-.75-.75-.75s-.75.34-.75.75V9.9H9.5c-.41 0-.75.34-.75.75s.34.75.75.75h1.75v1.81c0 .41.34.75.75.75s.75-.34.75-.75V11.4h1.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z"
})));